import React from 'react';
import styles from '../styles/components/_Card.module.scss';
import InfoBlock from './InfoBlock';
import { ReactComponent as PoneyclubLogo } from '../assets/images/poneyclubup.svg';

const FoodCard = ({
    mainImage,
    title,
    description,
    price,
    tags = [],
    onClick,
    cardColor = 'var(--white)',
}) => {
    const cardClasses = `
    ${styles.card} 
    ${styles.vertical}
    ${onClick ? styles.clickable : ''}
    ${styles.foodCard}
  `;

    return (
        <div
            className={cardClasses}
            onClick={onClick}
            style={{
                backgroundColor: cardColor,
            }}
        >
            <div className={styles.imageContainer}>
                {mainImage && (
                    <img
                        src={mainImage}
                        alt={title}
                        className={styles.mainImage}
                        loading="lazy"
                        decoding="async"
                    />
                )}
                <PoneyclubLogo
                    className={styles.overlayImage}
                    style={{
                        fill: cardColor,
                    }}
                />
            </div>

            <div className={styles.content}>
                <h3 className={styles.foodTitle}>{title}</h3>
                {description && (
                    <p className={styles.description}>{description}</p>
                )}
                {price && (
                    <div className={styles.price}>{price}€</div>
                )}
                {tags.length > 0 && (
                    <div className={styles.tags}>
                        {tags.map((tag, index) => (
                            <span key={index} className={styles.tag}>{tag}</span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default FoodCard;
